import request from '@/util/server.js'

// export const settled = 'http://localhost:8081' // 商家入驻地址
export const settled = 'http://114.246.242.223:9002/settled-merchant/#/' // 商家入驻地址

// 获取首页导航栏分类
export function getCategory () {
  return request({
    url: '/classify/getFirstClassify',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/nav.js